
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulated-waste-disposal",
      function () {
        return require("private-next-pages/regulated-waste-disposal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulated-waste-disposal"])
      });
    }
  